<template>
  <div>
    <PageTitle title="404 Page Not Found" />
    <h1>Yikes!</h1>
    <h1>Page Not Found!</h1>
    <h1>
      <router-link to="/">Home</router-link>
    </h1>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle'
export default {
  name: 'NotFound',
  components: { PageTitle }
}
</script>

<style scoped>
h1 {
  text-align: center;
}
</style>
